// extracted by mini-css-extract-plugin
export default {"detailsField":"open_vacancy-module___detailsField___fcb15c44"};